<template>
  <div class="prizes-2021-page">
    <MainBg />
    <div class="grid-box">
      <PageTitle tag="h1" class="text-uppercase">
        Призы red bull river runes
      </PageTitle>
      <div class="prizes-2021-page__prev-winners">
        <AppBtn
          class="prizes-2021-page__prev-btn"
          round
          color="orange-grad"
          to="/winners-2021"
        >
          <span>Победители Red Bull River Runes 2021</span>
        </AppBtn>
        <AppBtn
          class="prizes-2021-page__prev-btn"
          round
          color="blue-grad"
          to="/winners-2019"
        >
          <span>Победители Red Bull River Runes 2019</span>
        </AppBtn>
      </div>
      <Prizes2021Section place="1">
        <Prizes2021GamePlace />
      </Prizes2021Section>

      <Prizes2021Section
        v-for="section in prizesSections"
        :key="section.place"
        :place="section.place"
      >
        <Prizes2021PrizesList :list="section.prizes" />
      </Prizes2021Section>

      <Prizes2021Promo />
    </div>
  </div>
</template>

<script>
import MainBg from "@/components/common/MainBg";

import Prizes2021Section from "./Prizes2021Section";
import Prizes2021PrizesList from "./Prizes2021PrizesList";
import Prizes2021GamePlace from "./Prizes2021GamePlace";
import { prizesList } from "./data";
import Prizes2021Promo from "./promo/Prizes2021Promo";

export default {
  name: "Prizes2021Page",
  components: {
    MainBg,
    Prizes2021Section,
    Prizes2021GamePlace,
    Prizes2021PrizesList,
    Prizes2021Promo
  },
  computed: {
    prizesDict() {
      const dict = {};
      prizesList.forEach(item => (dict[item.id] = item));
      return dict;
    },

    prizesSections() {
      const prizesDict = this.prizesDict;
      return [
        {
          place: 2,
          prizes: [
            prizesDict["aoc-c27g2u"],
            prizesDict["cooler-master-caliber-r1"],
            prizesDict["hyperx-quadcast"],
            prizesDict["hyperx-alloy-origins"],
            prizesDict["hyperx-pulsefire-surge"],
            prizesDict["hyperx-fury-ultra"],
            prizesDict["cooler-master-jacket"]
          ]
        },
        {
          place: 3,
          prizes: [
            prizesDict["cooler-master-caliber-r1"],
            prizesDict["hyperx-alloy-origins"],
            prizesDict["hyperx-pulsefire-surge"],
            prizesDict["cooler-master-jacket"]
          ]
        },
        {
          place: "4-8",
          prizes: [
            prizesDict["cooler-master-mb511-argb"],
            prizesDict["hyperx-alloy-origins"],
            prizesDict["hyperx-pulsefire-surge"],
            prizesDict["cooler-master-tshirt"]
          ]
        },
        {
          place: "9-16",
          prizes: [
            prizesDict["cooler-master-mb511-argb"],
            prizesDict["hyperx-fury-ultra"],
            prizesDict["cooler-master-tshirt"]
          ]
        }
      ];
    }
  }
};
</script>

<style lang="scss">
.prizes-2021-page {
  padding-top: 100px;
  position: relative;
  z-index: 1;

  &__prev-winners {
    margin: 50px 0;
    text-align: center;
    width: 100%;

    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &__prev-btn {
    display: flex;
    max-width: 350px;
    &:not(:last-child) {
      margin-bottom: 10px;
    }
  }

  @include breakpoint("sm-and-down") {
    padding-top: 50px;

    &__prev-winners {
      margin: 40px 0;
      .btn {
        font-size: 12px;
      }
    }
  }
}
</style>
